const PATHNAME = location.pathname;

// close contact popup when already on the contact page, but preselect correct clinic
[...document.querySelectorAll('.contact-box__button')].forEach(anchor => {
    const HREF = anchor.getAttribute('href').split('#');

    if (HREF[0] == PATHNAME) {
        anchor.addEventListener('click', event => {
            event.preventDefault();
            window.emitter.emit('preselect-form', { preselect: HREF[1] });
            window.emitter.emit('close-dialog');
        });
    }
});
